/* eslint-disable @typescript-eslint/no-explicit-any */
// ** React Imports
import { Outlet } from 'react-router'
import { useEffect, useState } from 'react'

// ** Custom Hooks

// ** Third Party Components
import classnames from 'classnames'
import { useSkin } from '@src/utility/hooks/useSkin'

const BlankLayout = () => {
  // ** States
  const [isMounted, setIsMounted] = useState<boolean>(false)

  // ** Hooks
  const { skin } = useSkin()

  useEffect(() => {
    setIsMounted(true)
    return () => setIsMounted(false)
  }, [])

  if (!isMounted) {
    return null
  }

  return (
    <div
      className={classnames('blank-page', {
        'dark-layout': skin === 'dark'
      })}
    >
      <div className='app-content content'>
        <div className='content-wrapper'>
          <div className='content-body'>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BlankLayout
